import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import PanelComponent from '../components/shared_components/PanelComponent';
import ComparisonFormComponent from '../components/comparison/comparison_form/ComparisonFormComponent';
import ComparisonComparedProvidersOutputComponent from '../components/comparison/comparison_output/ComparisonComparedProvidersOutputComponent';
import LoaderComponent from '../components/shared_components/LoaderComponent';
import ComparisonSavingsComponent from '../components/comparison/comparison_output/ComparisonSavingsComponent';
import ErrorAlertComponent from '../components/shared_components/ErrorAlertComponent';

@observer
class ComparisonContainer extends React.Component {
  componentWillMount() {
    this.props.ComparisonFormData.comparedProviderData = [];
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const {
      responseError,
      errorFields,
      calculationResponseLoading,
      comparedProviderData,
    } = this.props.ComparisonFormData;
    const comparisonFormComponent = true;

    return (
      <div className="comparison-container">

        <div className="row comparison-container__header">
          <h1>Vergelijk twee geldverstrekkers</h1>
          <h1>Bereken uw besparing</h1>
        </div>

        <PanelComponent
          classNames={'row comparison-container__form-panel no-side-padding'}
          show={comparisonFormComponent}
        >

          <ErrorAlertComponent
            show={responseError}
            responseError={responseError}
            errorFields={errorFields}
          />

          <ComparisonFormComponent />

        </PanelComponent>

        <LoaderComponent
          show={calculationResponseLoading}
        />

        <PanelComponent
          classNames="row comparison-container__interest-comparison-graph"
          show={!_.isEmpty(comparedProviderData)}
        >
          <p className="bold">Vergelijking totale rentelast</p>

          <div className="medium-42 medium-centered columns">
            <ComparisonComparedProvidersOutputComponent />
          </div>

          <ComparisonSavingsComponent />

        </PanelComponent>
      </div>
    );
  }
}

ComparisonContainer.propTypes = {
  ComparisonFormData: PropTypes.shape({
    errorFields: PropTypes.arrayOf(PropTypes.shape({})),
    responseError: PropTypes.string,
    calculationResponseLoading: PropTypes.bool,
    comparedProviderData: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
  }),
};

ComparisonContainer.defaultProps = {
  ComparisonFormData: {
    errorFields: [],
    responseError: '',
    calculationResponseLoading: false,
    comparedProviderData: [],
  },
};

export default inject('ComparisonFormData')(ComparisonContainer);
